/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export class LinkAccess {
  ACCESSED_DATE: Date;
  IP_ADDRESS: string;
  BROWSER: string;
  LINK: string;
  CITY: string;
  COUNTRY: string;

  constructor(value: any = {}) {
    Object.assign(this, value);
  }

  static parseArray(json: any[]): LinkAccess[] {
    const arr = [];

    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(new LinkAccess(j));
        }
      }
    }

    return arr;
  }
}
